import * as api from '../services/agentRoster';

export const ROSTER_LOADING       = 'ROSTER_LOADING';
export const ROSTER_LOAD          = 'ROSTER_LOAD';
export const ROSTER_ERROR         = 'ROSTER_ERROR';
export const ROSTER_AUDIT_LOAD    = 'ROSTER_AUDIT_LOAD';
export const ROSTER_AUDIT_CLEAR   = 'ROSTER_AUDIT_CLEAR';

export const loadRoster = (agentType) => async (dispatch, getState) => {
  const type = agentType || getState().agentRoster.agentType;
  dispatch({ type: ROSTER_LOADING });
  try {
    const data = await api.getRoster(type);
    dispatch({ type: ROSTER_LOAD, payload: { ...data, agentType: type } });
  } catch (err) {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message;
    dispatch({ type: ROSTER_ERROR, payload: msg });
  }
};

/**
 * Promote a doctor row to a tele-caller. Returns:
 *   { ok: true,  agentName }                — caller closes modal
 *   { ok: false, code, message }            — caller surfaces error inline
 *
 * On success we reload the *current* roster (i.e. the doctor pool — the
 * promoted agent will simply disappear from it).
 */
export const promoteAgentToTc = (agentId, reason) => async (dispatch, getState) => {
  try {
    const data = await api.promoteToTc(agentId, reason);
    // Refresh the roster the user is looking at so the row goes away.
    const currentType = getState().agentRoster.agentType;
    dispatch(loadRoster(currentType));
    return { ok: true, agentName: data.message };
  } catch (err) {
    const resp = err.response && err.response.data;
    return {
      ok:      false,
      code:    resp && resp.code,
      message: (resp && resp.message) || err.message,
    };
  }
};

export const loadAudit = (agentId, limit) => async (dispatch) => {
  try {
    const data = await api.getAudit(agentId, limit);
    dispatch({
      type:    ROSTER_AUDIT_LOAD,
      payload: { agentId, audit: data.audit || [] },
    });
  } catch (err) {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message;
    dispatch({ type: ROSTER_ERROR, payload: msg });
  }
};

export const clearAudit = () => ({ type: ROSTER_AUDIT_CLEAR });
